module.exports = __webpack_public_path__ + "img/ios-1.f0c6ca8f.webp";